export default "__VITE_ASSET__D6_VWHJq__"